<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-container v-if="this.condition()" fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title>Certificats</v-card-title>

          <v-card-text>


            <img
                title="Entreprise inscrite à l'Orias" src="../../assets/logo_orias.png"
                v-if="this.etab_orias && this.etab_orias.informationBase.status=='Inscrit'"
                v-on:click="scrollMeTo('blocorias')"/>
            <img
                title="Entreprise radiée de l'Orias" src="../../assets/logo_orias_radie.png"
                v-if="this.etab_orias && this.etab_orias.informationBase.status=='Radié'"
                v-on:click="scrollMeTo('blocorias')"/>
             <img
                title="Entreprise inscrite à l'Orias sous un status inconnu" src="../../assets/logo_orias_inconnu.png"
                v-if="this.etab_orias && this.etab_orias.informationBase.status=='Inconnu'"
                v-on:click="scrollMeTo('blocorias')"/>
            <img
                title="Entreprise certifiée Qualibat" src="../../assets/logo_qualibat.png"
                v-if="this.certif_qualibat && !this.certif_qualibat_resiliation"
                v-on:click="scrollMeTo('blocqualibat')"/>
            <img
                title="Certificat Qualibat résilié ou suspendu" src="../../assets/logo_qualibat_resilie.png"
                v-if="this.certif_qualibat_resiliation"
                v-on:click="scrollMeTo('blocqualibat')"/>


             <img
                title="Entreprise certifiée Qualifelec" src="../../assets/logo_qualifelec.png"
                v-if="this.certif_qualifelec"
                v-on:click="scrollMeTo('blocqualifelec')"/>

             <img
                title="Entreprise certifiée RGE" src="../../assets/logo_france_renov.png"
                v-if="this.certif_rge"
                v-on:click="scrollMeTo('blocrge')"/>


            <img
                title="Etablissement certifié Qualité Tourisme"
                src="../../assets/logo_qualite_tourisme.png"
                v-if="this.certif_qualite_tourisme"
                v-on:click="scrollMeTo('bloctourisme')"/>

            <img title="Entreprise ayant des établissements certifiés Qualité Tourisme"
                 src="../../assets/logo_qualite_tourisme_etab.png"
                 v-if="this.etab_qualite_tourisme" v-on:click="scrollMeTo('bloctourisme')"/>

            <img title="Contrôles sanitaires"
                 src="../../assets/logo_alim_confiance_bleu.png"
                 v-if="this.etab_qualite_alim==0" v-on:click="scrollMeTo('blocalimconfiance')"/>

            <img title="Contrôles sanitaires"
                 src="../../assets/logo_alim_confiance_rouge.png"
                 v-if="this.etab_qualite_alim>0" v-on:click="scrollMeTo('blocalimconfiance')"/>

          </v-card-text>


        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.qualibat-overlay {
  color:red;
  font-weight: bold
}
</style>

<script>


export default {
  name: "Certificats",
  props: ["etablissement"],
  components: {},
  data: function () {
    return {}
  }
  ,
  computed: {
    risque_icon: function () {
      return "mdi-weather-windy"
    },
    certif_qualibat_resiliation: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualibatResiliations", null, "valeur")

    },
    certif_qualibat: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualibatCertificatURL", null, "valeur") || this.$store.getters.getbloc("certificats", "donnees", "qualibatCertificatRGEURL", null, "valeur")
    },
      certif_rge: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "rge_certif", null, "valeur")
    },
     certif_qualifelec: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualifelec_certificats", null, "valeur")
    },
    certif_qualite_tourisme: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualitetourisme_certificat", null, "valeur")
    },
    etab_qualite_tourisme: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualitetourisme_etablissements", null, "valeur")
    },
    etab_orias: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "orias", null, "valeur")
    },
     etab_qualite_alim: function () {
       var controle = this.$store.getters.getbloc("certificats", "donnees", "alimconfiance_inspection", null, "valeur")
       if (controle!=null && controle.length>0) {
         controle = controle.filter(item => item.alerte == 1);
           return controle.length
       }
       return null
    },

  },

  methods: {
    condition() {
      return this.etab_orias != null || this.certif_qualibat != null  || this.certif_qualite_tourisme != null || this.etab_qualite_tourisme != null || this.certif_qualifelec || this.certif_rge || this.etab_qualite_alim != null || this.certif_qualibat_resiliation != null
    },
  },
};
</script>
